import type { ExtensionPluginOptions } from '@atlaskit/editor-plugin-extension';

interface Props {
	options: Pick<
		ExtensionPluginOptions,
		'breakoutEnabled' | 'extensionHandlers' | 'appearance' | '__rendererExtensionOptions'
	>;
}

export function extensionPluginOptions({ options }: Props): ExtensionPluginOptions {
	return {
		breakoutEnabled: options.breakoutEnabled,
		extensionHandlers: options.extensionHandlers,
		useLongPressSelection: false,
		appearance: options.appearance,
		__rendererExtensionOptions: options.__rendererExtensionOptions,
	};
}
